import { datadogLogs } from '@datadog/browser-logs';
import { config } from '@uhg-abyss/web/tools/config';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getStackTrace } from '../../utils/error.utils';
import { isBlankAddress } from '../../utils/locationSearch.util';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import GetLocation from './Location.graphql';

export const useLocation = (options) => {
  const [isAWSLocationSearchEnabled] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.SWITCH_TO_AWS_LOCATION_SEARCH,
  ]);

  const [queryResult, queryAction] = useCustomQuery(GetLocation, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'location',
    ...options,
  });

  const parsedResult = (params) => {
    const address = params?.variables?.address;

    // prettier-ignore
    if (isBlankAddress(address))
      datadogLogs.logger.warn('[useLocation] Blank address, geocoding request skipped', { vars: params?.variables, pathname: window?.location?.pathname, stackTrace: getStackTrace(new Error()) });

    return queryAction({
      ...params,
      variables: {
        ...params?.variables,
        isAWSLocationSearchEnabled,
      },
    });
  };

  return [queryResult, parsedResult];
};
